// src/Nz.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Nz_default = createIcon({
  displayName: "Nz",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        id: "blue",
        x: "1.5",
        y: "1",
        width: "48",
        height: "32",
        fill: "#0070B8"
      }),
      /* @__PURE__ */ jsxs("g", {
        id: "UK corner",
        children: [
          /* @__PURE__ */ jsx("path", {
            id: "blue dark",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.5 1V17H25.5V1H1.5Z",
            fill: "#0070B8"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "white",
            d: "M4.20416 1L25.5 15.1972V17H22.7958L1.5 2.80278L1.5 1L4.20416 1Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "white_2",
            d: "M4.20416 17L25.5 2.80278V1L22.7958 1L1.5 15.1972L1.5 17H4.20416Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "red",
            d: "M1.5 1V2.20185L11.6972 9H13.5L1.5 1Z",
            fill: "#FF1A26"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "red_2",
            d: "M13.5 9V7.79815L23.6972 1H25.5L13.5 9Z",
            fill: "#FF1A26"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "red_3",
            d: "M25.5 17V15.7981L15.3028 9H13.5L25.5 17Z",
            fill: "#FF1A26"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "red_4",
            d: "M1.5 17L13.5 9V10.2019L3.30278 17H1.5Z",
            fill: "#FF1A26"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "white cross",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 1H11V6.5H1.5V11.5H11V17H16V11.5H25.5V6.5H16V1Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "red cross",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 1H12V7.5H1.5V10.5H12V17H15V10.5H25.5V7.5H15V1Z",
            fill: "#FF1A26"
          })
        ]
      }),
      /* @__PURE__ */ jsx("path", {
        id: "star",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M37.2562 4.48291L37.8677 6.5919H39.9394L38.2955 7.86225L38.9044 9.90354L37.2478 8.62338L35.5955 9.84213L36.2036 7.86171L34.5605 6.5919H36.589L37.2562 4.48291ZM43.8677 12.5919L43.2562 10.4829L42.589 12.5919H40.5605L42.2036 13.8617L41.5955 15.8421L43.2478 14.6234L44.9044 15.9035L44.2955 13.8623L45.9394 12.5919H43.8677ZM37.8677 24.5919L37.2562 22.4829L36.589 24.5919H34.5605L36.2036 25.8617L35.5955 27.8421L37.2478 26.6234L38.9044 27.9035L38.2955 25.8623L39.9394 24.5919H37.8677ZM31.8677 14.0919L31.2562 11.9829L30.589 14.0919H28.5605L30.2036 15.3617L29.5955 17.3421L31.2478 16.1234L32.9044 17.4035L32.2955 15.3623L33.9394 14.0919H31.8677Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "star_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M36.842 6.78718L36.699 6.89194H35.4395L36.4693 7.68785L36.521 7.85057L36.1493 9.06099L37.161 8.31477L37.3418 8.31679L38.3507 9.09646L37.9787 7.84942L38.0307 7.68785L39.0606 6.89194H37.7552L37.6111 6.78372L37.2438 5.51709L36.842 6.78718ZM42.699 12.8919L42.842 12.7872L43.2438 11.5171L43.6111 12.7837L43.7552 12.8919H45.0606L44.0307 13.6879L43.9787 13.8494L44.3507 15.0965L43.3418 14.3168L43.161 14.3148L42.1493 15.061L42.521 13.8506L42.4693 13.6879L41.4395 12.8919H42.699ZM36.699 24.8919L36.842 24.7872L37.2438 23.5171L37.6111 24.7837L37.7552 24.8919H39.0606L38.0307 25.6879L37.9787 25.8494L38.3507 27.0965L37.3418 26.3168L37.161 26.3148L36.1493 27.061L36.521 25.8506L36.4693 25.6879L35.4395 24.8919H36.699ZM30.699 14.3919L30.842 14.2872L31.2438 13.0171L31.6111 14.2837L31.7552 14.3919H33.0606L32.0307 15.1879L31.9787 15.3494L32.3507 16.5965L31.3418 15.8168L31.161 15.8148L30.1493 16.561L30.521 15.3506L30.4693 15.1879L29.4395 14.3919H30.699Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Nz_default
};
